<template>
  <el-dialog :append-to-body="true" title="内层UDI" :visible="visible"  @close="$emit('close')">
    <div v-loading="loading" style="height: 85vh;overflow-y: auto">
      <el-tree
        class="rela-tree"
        :data="udiTree"
        :props="defaultProps"
        :expand-on-click-node="false"
        empty-text="暂无关联关系"
        highlight-current
        default-expand-all
      >
        <div slot-scope="{ data }" style="display: flex; align-items: center">
          {{ data.completeUdi }}
        </div>
      </el-tree>
    </div>
  </el-dialog>
</template>

<script>

import { getCodePackInfo, } from "@/api/warehousingOrder";

export default {
  name: 'InnerLayerUdiDialog',
  props: {
    completeUdi: {
      type: Array,
      default: () => {
        return ''
      }
    },
    visible: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data: () => {
    return {
      udiTree: [], // udi树
      loading:false,
      defaultProps: {
        children: 'childList',
        label: 'completeUdi'
      },
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 获取内层数据
    getList() {
      this.loading = true
      getCodePackInfo(this.completeUdi)
        .then((res) => {
          if (res.code === 200) {
            this.udiTree = res.data.udiCodeList
          } else {
            this.udiTree = []
          }
        }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.tips {
  margin-bottom: 12px;
  font-size: 14px;
  color: #fa8c16;
}
</style>
